export default __webpack_public_path__ + "static/media/P20004.81474a95.png";